import { get, post } from '../config/$ajax.js';

/**
 * 获取我的供销商
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const querySupplierPageList = (data = {}) => {
  return get(`/dms/querySupplierPageList`, data, { isNeedLoading: false });
};
// 获取供销商主图
export const querySupplierTopMainPicApi = (data = {}) => {
  return get(`/dms/querySupplierTopMainPic`, data, { isNeedLoading: false });
};
/**
 * 获取单个供销商的采购信息
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryCartInfo = (data = {}) => {
  return post(`/distribution/shop/purchase/cart/get`, data, {submitType: 'json', isNeedLoading: false });
};

/**
 * 更新-自动同步商品配置
 * @param {*} data
 * @param {*} params
 * @returns
 */
 export const updateAutoSyncDistributionItem = (data = {}, params = {submitType: 'json' }) => {
  return post(`/dms/updateAutoSyncDistributionItem`, data, params);
};


/**
 * 根据分销商ID查询分销商详情
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryDistributors = (data = {}, params = {}) => {
  return get(`/dms/queryDistributors`, data, params);
};

/**
 * 分销商修改供销商信息
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const updateSupplierInfo = (data = {}, params = { submitType: 'json' }) => {
  return post(`/dms/updateSupplierInfo`, data, params);
};

/**
 * 查询自定义字段集合
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryCustomNameList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/customField/queryCustomNameList', data);
  return res;
};
/**
 * 获取供销商服务信息
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryDmsCompanyInfo = (data = {}, params = {}) => {
  return get(`/dms/queryDmsCompanyInfo`, data, params);
};

/**
 * 获取供销商服务信息
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const disInviteSupplierUrl = (data = {}, params = {}) => {
  return get(`/short/pc/create/disInviteSupplierUrl`, data, params);
};

/**
 * 设置合作是否需要审核
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const isToExamine = (data = {}, params = { submitType: 'json' }) => {
  return post(`/dms/saveOrUpdateConfig`, data, params);
};

/**
 * 获取业务员列表
 * @param {} data
 * @param {*} params
 * @returns
 */
export const toDistributionStaff = (data = {}, params = {}) => {
  return get(``, data, params);
};

/**
 * 我的分销商合作状态操作
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const optCooperateState = (data = {}, params = { submitType: 'json' }) => {
  return post(`/dms/optCooperateState`, data, params);
};

/**
 * 共分销关系绑定
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const relationBind = (data = {}, params = { submitType: 'json' }) => {
  return post(`/dms/relationBind`, data, params);
};

/**
 * 获取分销价
 * @returns
 */
export const getDistributionPrice = () => {
  return get('/dms/getDistributionPrice');
};
/**
 * 设置分销价
 * @returns
 */
export const setDistributionPrice = (data = {}, params = { submitType: 'json' }) => {
  return post('/dms/submitSyncDistributionPriceTask', data, params);
};

/**
 * 供销商-设置/取消供销商品
 * @returns
 */
export const setDistributionGoods = (data = {}, params = { submitType: 'json' }) => {
  return post('/supplierGoods/setDistributionGoods', data, params);
};

/**
 * 供销商-供销商品列表
 * @returns
 */
export const distributionGoodsList = (data = {}, params = { submitType: 'json' }) => {
  return post('/supplierGoods/distributionGoodsList', data, params);
};

/**
 * 供销商-批量修改分销价接口(spu级别)
 * @returns
 */
export const batchEditDistributionPrice = (data = {}, params = { submitType: 'json' }) => {
  return post('/supplierGoods/batchEditDistributionPrice', data, params);
};

/**
 * 供销商-设置分销价格列表查询
 * @returns
 */
export const findItemDistributionPrice = (data = {}, params = {}) => {
  return get('/supplierGoods/findItemDistributionPrice', data, params);
};

/**
 * 供销商-分销价保存接口
 * @returns
 */
export const itemSkusDistributionPriceSave = (data = {}, params = { submitType: 'json' }) => {
  return post('/supplierGoods/itemSkusDistributionPriceSave', data, params);
};

/**
 * 查询分销商品规则
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryRuleList = (data = {}, params = { submitType: 'json' }) => {
  return post('/dms/queryItemRuleList', data, params);
};

/**
 * 分销规则 (新增,修改)
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const updateRule = (data = {}, params = { submitType: 'json' }) => {
  return post('/dms/saveItemRuleInfo', data, params);
};

/**
 * 查询分销规则详情
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryRuleInfo = (data = {}, params = { submitType: 'json' }) => {
  return post('/dms/queryItemRuleInfo', data, params);
};

import { getErpHost } from '@/utils/domainHelper.js';
const API_HOST = getErpHost();

/**
 * 调教新增支付
 */
export const addPayInfo = async (data = {}) => {
  const res = await post(API_HOST + 'dms/addPayInfo', data, { submitType: 'json' });
  return res;
};

/**
 * 查询分销余额
 * @param {*} data
 * @returns
 */
export const queryDmsDistributorInfo = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryDmsDistributorInfo', data);
  return res;
};

/**
 * 该供销商是否开通网商银行
 */
 export const queryStatusOfBank = async (data = {}) => {
  const res = await get(API_HOST + 'fms/account/countPaymentAccount', data);
  return res;
};
/**
 * 该供销商开通哪些网商账号
 */
 export const getPaymentAccountList = async (data = {}) => {
  const res = await get(API_HOST + 'fms/account/getPaymentAccountList', data);
  return res;
};

/**
 * 支付状态
 */
 export const getPaymentStatus = async (data = {}) => {
  const res = await get(API_HOST + 'fms/accountPayment/detail', data);
  return res;
};


/**
 * 流水信息查询接口
 */
export const queryByFlowNumber = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryByFlowNumber', data);
  return res;
};



/**
 * 查看资金流水
 * @param {*} data
 * @returns
 */
export const getDmsCashFlowPageList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/dmsCashFlowPageList', data);
  return res;
};

/**
 * 查询所有店铺
 * @param {*} data
 * @returns
 */
export const getShopInfoLight = async (data = {}) => {
  const res = await get(API_HOST + 'shop/info/light', data, { submitType: 'json' });
  return res;
};

/* --- 查看分销商品管控价-----*/
export const queryControlPrice = (params, config) => {
  return post('/item/distributor/queryControlPrice', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};

/**
 * 订单对账明细
 * @param {*} data
 * @returns
 */
export const queryStatementAsList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryStatementAsList', data);
  return res;
};

/**
 * 订单对账明细
 * @param {*} data
 * @returns
 */
export const queryStatementTradeList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryStatementTradeList', data);
  return res;
};

/**
 * 订单对账明细
 * @param {*} data
 * @returns
 */
export const queryStatementDkTradeList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryStatementDkTradeList', data);
  return res;
};

/**
 * 获取批发收银结算单
 * @param {*} data
 * @returns
 */
export const queryStatementDkPageList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryStatementDkPageList', data);
  return res;
};

/**
 * 审核通过、作废
 * @param {*} data
 * @returns
 */
export const optStatementDk = async (data = {}) => {
  const res = await post(API_HOST + 'dms/optStatementDk', data);
  return res;
};

/**
 * 新建快麦结算单
 * @param {*} data
 * @returns
 */
export const createStatementKm = async (data = {}) => {
  const res = await post(API_HOST + 'dms/createKmRctStatement', data, { submitType: 'json' });
  return res;
};
// 修改备注
export const updateStatementRemark = async (data = {}) => {
  const res = await post(API_HOST + 'dms/updateStatementRemark', data, { submitType: 'json' });
  return res;
};


/**
 * 审核通过、作废
 * @param {*} data
 * @returns
 */
export const optStatement = async (data = {}) => {
  const res = await get(API_HOST + 'dms/optStatement', data);
  return res;
};

/**
 * 获取结算单
 * @param {*} data
 * @returns
 */
export const queryStatementPageList = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryStatementPageList', data);
  return res;
};

/**
 * 获取上次结算时间
 * @param {*} data
 * @returns
 */
export const queryLastStatementDkTime = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryLastStatementDkTime', data);
  return res;
};
export const queryLastStatementTime = async (data = {}) => {
  const res = await get(API_HOST + 'dms/queryLastStatementTime', data);
  return res;
};

/**
 * 添加支付 导出
 * @param {*} params
 * @returns
 */
export const boolExportCashFlow = async params => {
  const res = await get(API_HOST + 'dms/boolexport/cashFlow', params);
  return res;
};
export const exportExcelCashFlow = async params => {
  const res = await get(API_HOST + 'dms/exportExcel/cashFlow', params);
  return res;
};

/**
 * 售后明细 导出
 * @param {*} params
 * @returns
 */
export const boolExportStatement = async params => {
  const res = await get(API_HOST + 'dms/boolexport/statement/asDetail', params);
  return res;
};
export const exportExcelStatement = async params => {
  const res = await get(API_HOST + 'dms/exportExcel/statement/asDetail', params);
  return res;
};

/**
 * 售后明细 导出
 * @param {*} params
 * @returns
 */
export const boolExportStatementTradeDetail = async params => {
  const res = await get(API_HOST + 'dms/boolexport/statement/dk/tradeDetail', params);
  return res;
};
export const exportExcelStatementTradeDetail = async params => {
  const res = await get(API_HOST + 'dms/exportExcel/statement/dk/tradeDetail', params);
  return res;
};

/**
 * 订单对账明细 导出
 * @param {*} params
 * @returns
 */
export const dmsBoolexportStatementTradeDetail = async params => {
  const res = await get(API_HOST + 'dms/boolexport/statement/tradeDetail', params);
  return res;
};
export const dmsExportExcelStatementTradeDetail = async params => {
  const res = await get(API_HOST + 'dms/exportExcel/statement/tradeDetail', params);
  return res;
};

// 导出结算单
export const queryLastFileUrl = async (data = {}) => {
  const res = await post(API_HOST + 'dms/queryLastFileUrl', data, { submitType: 'json'});
  return res;
};


/**
 * 查询可分销商品的总数量
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
export const queryItemRuleInfo = (data = {}, params = { submitType: 'json'}) => {
  return post('/distribution/shop/item/count', data, params)
}

/**
 * 获取分销等级数据
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryLevelList = (data = {}, params = {}) => {
  return get(`/dms/queryLevels`, data, params);
};

// 刷新历史订单分销价
export const dmsRefreshPrice = params => {
  return post(API_HOST + 'trade/dms/refreshPrice', params).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 刷新历史订单分销价进度条
export const progressQuery = params => {
  return post(API_HOST + 'trade/progress/query', params, {isNeedLoading: false}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};
export const getAllSellerCat = (data = {},  params = {}) => {
  return get('/seller/getAllSellerCat', data)
}

// 修改共享分享小店商品
export const queryDefaultPriceRule = function(data) {
  return post('/dms/queryDefaultPriceRule', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}

// 判断编辑分销商品规则时，当前供销商是否在按分销等级设置规则的白名单里
export const isInDistributorLevelSetWhitelist = params => {
  return get('/dms/whiteList/hasHisLevelWhitelist', params, {isNeedLoading: false}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};
// 商品供分销关系透出-分页查询
export const supplierKmtfxItemManagePage = function(data) {
  return post('/kmtfx/item/supplier/manage/page', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}

// 商品供分销关系透出-详情
export const supplierKmtfxItemManageDetail = function(data) {
  return post('/kmtfx/item/supplier/manage/detail', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}

// 商品供分销关系透出-解绑
export const supplierCancelFxItem = function(data) {
  return post(`/kmtfx/item/supplier/manage/cancelFxItem`, data, {appJson: true, submitType: 'json'})
}

// 商品供分销关系透出-批量解绑
export const supplierBatchCancelFxItem = function(data) {
  return post(`/kmtfx/item/supplier/manage/submit/batchCancelFxItem`, data, {appJson: true, submitType: 'json'})
}

// 自动绑定kmt 供分销商品
export const supplierAutoBindKmtItem = function (data) { 
  return post('/kmtfx/item/supplier/manage/autoBindKmtFxItem', data, { appJson: true, submitType: 'json' })
}

// 商品供分销关系透出-换绑
export const supplierBindKmtFxItem = function(data)  {
  return post(`/kmtfx/item/supplier/manage/coverBindKmtFxItem`, data, {appJson: true, submitType: 'json'})
}

// 商品供分销关系透出-查询日志
export const supplierKmtfxItemLogPage = function(data) {
  return post(`/kmtfx/item/supplier/manage/searchLogPage`, data, {appJson: true, submitType: 'json'})
}

// 商品供分销关系透出-供销商商品列表
export const getKmtfxSupplierItemList = function(data) {
  return post('/kmtfx/item/supplier/manage/dms/supplierPromotionShopItemList', data, {appJson: true, submitType: 'json'})
}

// 刷新历史订单分销价
export const itemStatusWhitelist = () => {
  return get('/sync/distribution/item/syncXdItemStatusWhitelist', {}, {isNeedLoading: false}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};
// 校验是否开启 下载自动加入分销小店
export const checkDownloadAutoJoinShopApi = function(data) {
  return post(`/scmCompanyConf/checkDownloadAutoJoinShop`, data, {appJson: true, submitType: 'json'})
}

// 更新简称
// 校验重复
export const reqCheckSupplierAliasName = (data = {}) => {
  return post(API_HOST + 'dms/checkSupplierAliasName', data, { submitType: 'json', isNeedLoading: false });
};
export const reqUpdateSupplierInfo = (data = {}) => {
  return post(API_HOST + 'dms/updateSupplierInfo', data, { isNeedLoading: false });
}

/**
 * 置顶/取消置顶供销商
 * @param {{ contractId: number|string, topFlag: 0|1 }} data
 */
export const updateSupplierTop = (data = {}, params = {}) => {
  return get('/dms/updateSupplierTop', data, params);
};

/**
 * 查询置顶供销商数量
 */
export const getSupplierTopCount = (data = {}, params = {}) => {
  return get('/dms/getSupplierTopCount', data, params);
};